var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"assignees-filter"},[_c('sk-multiselect',{attrs:{"items-list":_vm.managers,"preselected-value":_vm.filterAssignees,"default-value":_vm.defaultValue},on:{"checkboxeschanged":_vm.onInputBoxChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }